import type { FilesPort, RawFile } from '@kc/core/ports'

/**
 * 内容包在内存里的快照。openWorkspace 只在 reload 时调用 readConceptFiles，
 * 所以内容更新时先 setFiles 再 workspace.reload()，队列与库会一起重建。
 */
export class ContentFilesPort implements FilesPort {
  #files: readonly RawFile[]

  constructor(files: readonly RawFile[]) {
    this.#files = files
  }

  setFiles(files: readonly RawFile[]): void {
    this.#files = files
  }

  async readConceptFiles(): Promise<readonly RawFile[]> {
    return this.#files
  }
}
